export default {
  levelSelected: null,
};
